$(function () {
   // STICKY
   $('#shopify-section-hair-care-gallery').addClass('js-sticky-widget').attr({'data-margin-top': '85', 'data-sticky-for': '1023', 'data-sticky-class': 'is-sticky'});
   var sticky = new Sticky('.js-sticky-widget');


   // ACCORDIONS
   $('.pdp__Accordions__title').on('click', function () {
      if (!$(this).parent().hasClass('active')) {
         $('.pdp__Accordions__item').removeClass('active')
         $(this).parent().addClass('active');
      } else {
         $(this).parent().removeClass('active');
      }

      var wrapper = $(this).offset().top;
      console.log($(this));
      var offset = wrapper - 350;
      // $('html,body').animate({
      //    scrollTop: offset
      // }, 600);

   })

   // HOW TO USE
   $('.pdp__Howto--menu li').on('click', function (e) {
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      let index = e.target.dataset.id;

      $('.pdp__Howto--content').removeClass('active')
      $(`.pdp__Howto--content[data-id=${index}]`).addClass('active')

      var wrapper = $('.pdp__Howto--menu').offset().top;
      var offset = wrapper - 350;
      // $('html,body').animate({
      //    scrollTop: offset
      // }, 300);

setTimeout(() => {
   sticky.update();
}, 400);
      setTimeout(() => {
         $(`.pdp__Howto--content[data-id=${index}]`).focus();

      }, 100);
   })

   // INGREDIENTS
   function changeIngredients(sku) {
   $('.buy-now-at-retailers').hide();
  $('#variant_'+sku).show();
     

      var imgdata = $('.product-slider-tabbing li.active .product-slider-tab')
      if (!sku) {
         sku = imgdata.attr("sku");
      }

      $('.pdp__Ingredients--item').each(function () {
         if (sku == $(this).attr("sku")) {
            $(this).removeClass("hide");
         }
         else {
            $(this).addClass("hide");
         }
      });
   }

 //  changeIngredients();

   $(".counter-product .product-slider-tabbing a").on("click", function () {
      var sku = $(this).find('.product-slider-tab').attr("sku");
      changeIngredients(sku);
   });

   //BENEFITS
   $('.pdp__Benefits__menu li').on('click', function (e) {
      $(this).siblings().removeClass('active');
      $(this).addClass('active');
      let index = e.target.dataset.id;

      $('.pdp__Benefits__content').removeClass('active')
      $(`.pdp__Benefits__content[data-id=${index}]`).addClass('active')
   })

   // SHADES
   $('.pdp__Shades__left--menu li').on('click', function (e) {
      let id = e.target.dataset.id;
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      $('.pdp__Shades__right--item').removeClass('active');
      $(`.pdp__Shades__right--item[data-id=${id}]`).addClass('active')
   })
   $('.pdp__Shades__right--item li button').on('click', function (e) {
      var sku = $(this).attr('id');
      var index = $(`.pdp__Shades__modal .slick-slide[sku="${sku}"]`).data('slick-index')
      var modal = $(this).parent().parent().attr('data-id')

      $('.pdp__Overlay').show();
      $(`.pdp__Shades__modal--${modal}`).show();

     $(`.pdp__Shades__modal--${modal}`).slick('refresh');

     

      setTimeout(() => {
         $(`.pdp__Shades__modal--${modal}`).slick('slickGoTo', index)
      }, 100);
   })
   $('.pdp__Shades__modal--blacks').slick({
      slidesPerRow: 1,
      adaptiveHeight: true,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev"><p hidden>prev</p><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8156 12.0266L1.66583 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.2407 1.45117L1.66583 12.0261L12.2407 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><p hidden>next</p><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51604 12.0266L22.6658 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.0909 1.45117L22.6658 12.0261L12.0909 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   });
   $('.pdp__Shades__modal--blondes').slick({
      slidesPerRow: 1,
      adaptiveHeight: true,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev"><p hidden>prev</p><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8156 12.0266L1.66583 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.2407 1.45117L1.66583 12.0261L12.2407 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><p hidden>next</p><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51604 12.0266L22.6658 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.0909 1.45117L22.6658 12.0261L12.0909 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   });
   $('.pdp__Shades__modal--reds').slick({
      slidesPerRow: 1,
      adaptiveHeight: true,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev"><p hidden>prev</p><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8156 12.0266L1.66583 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.2407 1.45117L1.66583 12.0261L12.2407 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><p hidden>next</p><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51604 12.0266L22.6658 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.0909 1.45117L22.6658 12.0261L12.0909 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
   });
   $('.pdp__Overlay').on('click', e => {
      $('.pdp__Overlay').hide();
      $('.pdp__Shades__modal').hide();
   })

   // BSUB

   $('.pdp__Bsub__dropdown--active').text($('.pdp__Bsub__dropdown__wrapper--item input[data-bsub-selling-plan-input]:checked + label').text());

   $('.template-haircolor .bsub-trigger').on('click', function (e) {
      e.preventDefault();
      window.scrollTo(0, 0);
      setTimeout(() => {
         $('.pdp__Bsub').show();
         $('.pdp__AddToCart').hide();
         $('body').css('overflow', 'hidden');
      }, 200);
      $('.bsub__variant').text($('.selected-item-div span').text())
      $('.bsub-save').trigger('click')
   })

   $('.pdp__Bsub__back').on('click', function () {
      window.scrollTo(0, 0);
      $('.pdp__Bsub').hide();
      $('body').css('overflow', '');
      $('.pdp__AddToCart').show();
   })

   $('.pdp__Bsub__dropdown__active').on('click', function () {
      $('.pdp__Bsub__dropdown__wrapper').toggleClass('active');
   })

   $('.pdp__Bsub__dropdown__wrapper--item').on('click', function () {
      $('.pdp__Bsub__dropdown--active').text($(this).text());
      $('.pdp__Bsub__dropdown__wrapper').removeClass('active')
      $('.pdp__Bsub__widget.bsub__subs .bsub-widget__input').attr('checked', 'true');
   })

   $('.pdp__Bsub__addToCart').on('click', function (e) {
      $('.pdp__AddToCart').show();
      $('.pdp__Bsub').hide();
      $('body').css('overflow', '');
   })

   $('.pdp__Bsub__extra input').on('input', function (e) {
      var quantity = $('.counter-product-wrapper input[name="quantity"]').val()
      if ($(this).is(':checked')) {
         $('.counter-product-wrapper input[name="quantity"]').val(parseInt(quantity) + 1)
      } else {
         $('.counter-product-wrapper input[name="quantity"]').val(parseInt(quantity) - 1)
      }
   })

   // YESNO SECTION

   if ($(window).width() < 768) {
      $(".yes-image-listing-block .right-image-block ul").slick({
         arrows: true,
         infinite: false,
         prevArrow: '<button type="button" class="slick-prev"><p hidden>prev</p><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8156 12.0266L1.66583 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.2407 1.45117L1.66583 12.0261L12.2407 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
         nextArrow: '<button type="button" class="slick-next"><p hidden>next</p><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.51604 12.0266L22.6658 12.0266" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.0909 1.45117L22.6658 12.0261L12.0909 22.601" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
         responsive: [
            {
               breakpoint: 9999,
               settings: "unslick"
            },
            {
               breakpoint: 576,
               settings: {
                  slidesToShow: 3
               }
            }
         ]
      });
      $(".pdp__Howto--menu").slick({
         arrows: true,
         infinite: false,
         nextArrow: '<button type="button" class="slick-next"><p hidden>next</p><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.30908 11.0322L6.30908 6.03223L1.30908 1.03223" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
         variableWidth: true,
         responsive: [
            {
               breakpoint: 9999,
               settings: "unslick"
            },
            {
               breakpoint: 576,
               settings: {
                  slidesToShow: 3.5
               }
            }
         ]
      });
   }

   // ADA

   $('.selected-item-div').on('keydown', function (e) {
      if (e.keyCode == 13) {
         $(this).trigger('click');
         setTimeout(() => {
            $('.selected-item-div').focus();
         }, 100);
      }
   })
   $('.new-select-dropdown').on('keydown', function (e) {
      if (e.keyCode == 27) {
         $('.selected-item-div').trigger('click');
      }
   })

   $('.pdp__Shades__left--menu li').on('keydown', function (e) {
      var data = e.target.dataset.id;
      console.log(data);
      if (e.keyCode == 13) {
         $(this).trigger('click');
         setTimeout(() => {
            $(`.pdp__Shades__right--item[data-id="${data}"] li:first-child()`).focus();
         }, 100);
      }
   });

   $('.pdp__Accordions__title').on('keydown', function (e) {
      console.log(e.keyCode);
      if (e.keyCode == 13) {
         $(this).trigger('click');
      }
   })

   $('.pdp__Howto--menu li').on('keydown', function (e) {
      if (e.keyCode == 13) {
         $(this).trigger('click');
      }
   });
});